<template lang="pug">
.nav-item
  router-link(tag="li", :to="href", active-class="active", exact)
    a(:href='href')
      p(@click='$emit("click")')
        span(:class='icon')
        | &nbsp;
        | {{title}}
  .subnav
    slot
</template>

<script>
export default {
  props: {
    icon: String,
    title: String,
    href: String
  }
}
</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

.nav-item {
  margin-left: 10px;
  p {
    padding-left: 5px;
  }

  &:hover li > a > p {
    background: rgba(200, 200, 200, 0.2);
  }
}

.subnav a {
  font-size: $font-size-base-sm;
  display: block;
  margin-left: 30px;
  @include theme {
  color: v(canvas);
  }
  opacity: .85;

  &:hover {
    opacity: .5;
    text-decoration: underline
  }
}
  
</style>



// WEBPACK FOOTER //
// src/components/Sidebar/item.vue